import { render, staticRenderFns } from "./hotel-constructor.vue?vue&type=template&id=3cb47af2&"
import script from "./hotel-constructor.vue?vue&type=script&lang=ts&"
export * from "./hotel-constructor.vue?vue&type=script&lang=ts&"
import style0 from "./hotel-constructor.vue?vue&type=style&index=0&id=3cb47af2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports